module.exports = __webpack_public_path__ + "285467176f7fe6bb6a9c6873b3dad2cc.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-500.woff2
// module id = 667
// module chunks = 0